module.exports = __webpack_public_path__ + "static/media/chat01.60b70592.gif";